import axios from "axios";
import { ComponentEndorsements, GetEndorsementsListResponse } from "../../interfaces/services/endorsement-list-service";
import { displayErrorMessage, getError, getUserInfo } from "../../utils";
import CustomHttpClient from "../customHttpClient";

const customHttpClient = CustomHttpClient({ baseUrl: 'productores/endosos' });

const { REACT_APP_LAMBDA_VAIS_URL } = process.env;

const EmissionService = {

    async getEndorsementsElevatorsBoilersList(): Promise<GetEndorsementsListResponse> {
        const url = 'listaAumentoSumaAscensoresCalderas';
        const params = {
            ...getUserInfo(),
        };
    
        try {
            const response = await customHttpClient.get(url, { params });
    
            return response.data;
        } catch (error) {
            throw new Error(getError(error));
        }
    },

    async getEndorsementsCars(): Promise<GetEndorsementsListResponse> {
        const url = 'listaAumentoSumaAutos';
        const params = {
            ...getUserInfo(),
        };
    
        try {
            const response = await customHttpClient.get(url, { params });
    
            return response.data;
        } catch (error) {
            throw new Error(getError(error));
        }
    },

    async postExecuteEndorsementsElevatorsBoilers(endorsement: ComponentEndorsements): Promise<number> {
        const url = 'ejecutarEndosoAumentoDeSumaAscensoresyCalderas';

        const body = {
            ...getUserInfo(),
            articulo: endorsement.articulo ,
            superpoliza: endorsement.superpoliza ,
            rama: endorsement.rama ,
            arse: endorsement.arse ,
            operacion: endorsement.operacion ,
            componente: endorsement.numeroComponente
        };
    
        try {
            const response = await customHttpClient.post(url, body);
    
            return response.data;
        } catch (error) {
            throw new Error(getError(error));
        }
    },

    async postExecuteCarsEndorsements(endorsement: ComponentEndorsements): Promise<number> {
        const url = 'ejecutarAumentoDeSumaAutos';

        const body = {
            ...getUserInfo(),
            articulo: endorsement.codArticulo ,
            superpoliza: endorsement.nroSuperPoliza ,
            rama: endorsement.codRama ,
            arse: endorsement.nroArse ,
            operacion: endorsement.nroOperacion ,
            componente: endorsement.nroComponente
        };
    
        try {
            const response = await customHttpClient.post(url, body);
    
            return response.status;
        } catch (error) {
            throw new Error(getError(error));
        }
    },

    async postLambaVais(): Promise<string | undefined> {        
        const url = REACT_APP_LAMBDA_VAIS_URL;
          const userInfo = getUserInfo();
          const body = {
            nivel: userInfo.nit1,
            codigo: userInfo.niv1,
          };
        try {
            const response = await axios.post<{url: string}>(url!, body);
            if (response.status === 200 && response.data) {                
                return response.data.url;
              } else {
                displayErrorMessage('¡Ups, ocurrió un error! - API VAIS: Respuesta no válida.');
              }
        } catch (error) {
            throw new Error(getError(error)); 
        }
    }
}

export default EmissionService;
